// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import VueAxios from 'vue-axios'
import qs from 'qs'

import '../theme/index.css'
import ElementUI from 'element-ui'
// import 'element-ui/lib/theme-chalk/index.css'
import './assets/css/login.css'
import base64 from 'base-64'
import Cookies from 'js-cookie'
import zmPhotoGallery from './packages/zm-photo-gallery'

Vue.prototype.Host = '/api'

Vue.use(VueAxios, axios)
Vue.prototype.$base64 = base64
Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.use(zmPhotoGallery)

// 配置全局导航过滤，拦截路由请求
router.beforeEach((to, from, next) => {
  // TODO 检查bindbindAccount路由， next
  if (to.path == '/bindQq.html' || to.path == '/bindWx.html' || to.path == '/crossIndex.html' || to.path == '/storeAuth.html' || to.name == 'activation' || to.path == '/bindAliyun.html') {
    next()
  } else if (to.meta.isLogin === false) {
    next()
  } else {
    // var user = localStorage.getItem('mytoken');
    let user = Cookies.get('qm_account_token')
    if (user) {
      if (to.path == '/login.html') {
        next({ path: '/index.html' })
      } else {
        next()
      }
    } else {
      if (to.path !== '/login.html') {
        if (to.path === '/register.html' || to.path == '/getPassword.html' || to.path == '/agreement.html' || to.path == '/toLoad.html' || to.path == '/login-li.html') {
          next()
        } else {
          next({ path: '/login.html' })
        }
      } else {
        next()
      }
    }
  }
})

// 处理框架非框架
if (window.top !== window.self) { window.top.location = window.location }
// 处理框架非框架
/*
* 统一接口
*/

// 获取当前域名
var domain_str = location.hostname.split('.')
var domain = domain_str[domain_str.length - 2] + '.' + domain_str[domain_str.length - 1]
// alert(domain);

// 初始化SDK事件名称
// QM.apiCheckCallFun = 'apiCheckError';		//用户检查登录情况的事件执行/
QM.apiErrorCallFun = 'apiError'			// 接口返回错误的事件执行
QM.version = '1.0'							// 定义版本号

// 检查用户登录状态，存在的，直接进入到首页
QM.apinew({
  url: '/seller/user/check-login',
  method: 'post',
  data: {},
  success: function (xdata) {
    // location.href = "index.html";
  },
  error: function (xdata) {
    // router.push({path: 'login'});
    localStorage.removeItem('mytoken') // 用户登录账号过期后清除token值和手机号，跳转重新登录页面由路由守卫判断
    localStorage.removeItem('mobile')
    // 自定义错误，覆盖初始化加载的错误指向，不返回
  }
})

new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})